import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FoodTone } from '../../core/models/menu.model';
import { IconComponent } from './icon.component';
import { toneDef } from './food-tones';

/** CSS gradient food placeholder keyed by tone (no photo). */
@Component({
  selector: 'app-food-img',
  standalone: true,
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div [style.border-radius.px]="radius" [style.background]="def.g"
      style="position:relative;overflow:hidden;width:100%;height:100%">
      <div style="position:absolute;inset:0;background:radial-gradient(80% 60% at 50% 120%, rgba(0,0,0,0.34), transparent 70%)"></div>
      <div style="position:absolute;inset:0;opacity:0.16;display:flex;align-items:center;justify-content:center">
        <app-icon [name]="def.icon" [size]="iconSize" color="#fff"></app-icon>
      </div>
      <div style="position:absolute;top:0;left:0;right:0;height:45%;background:linear-gradient(180deg, rgba(255,255,255,0.22), transparent)"></div>
    </div>`,
})
export class FoodImgComponent {
  @Input() tone: FoodTone = 'beef';
  @Input() radius = 14;
  @Input() iconSize = 64;
  get def() { return toneDef(this.tone); }
}
